import { useMemo } from "react";
import {
  findActiveGroup,
  findActiveItem,
  getPrevNextItems,
} from "../utils/docUtils/docsNavigationSelectors";

export function useDocsNavigation(docNav, activeId) {
  return useMemo(() => {
    const active = findActiveItem(docNav, activeId);
    const { prev, next } = getPrevNextItems(docNav, activeId);
    return {
      activeGroup: active?.group ?? findActiveGroup(docNav, activeId),
      activeItem: active?.item ?? null,
      prev,
      next,
    };
  }, [docNav, activeId]);
}
